import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, Divider, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ marginTop: 5 }}>
      <Box sx={{ backgroundColor: '#ffffff', padding: 4, borderRadius: 2, boxShadow: 2 }}>
        
        {/* Back Button */}
        <Button variant="contained" color="primary" onClick={() => navigate(-1)} sx={{ marginBottom: 2 }}>
          ← Back
        </Button>

        <Typography variant="h4" gutterBottom align="center" color="primary">
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" gutterBottom align="center" color="textSecondary">
          <strong>Last Updated: 28th Mar 2025</strong>
        </Typography>

        <Typography variant="body1" paragraph>
          This Privacy Policy describes how Smyan Tech Solutions Pvt Ltd (herein “Dequitec”, "we," "us," or "our") collects,
          uses, and shares information about you when you use our website, www.dequitec.com (the "Site"), to analyze,
          compare, and connect with business loan providers ("Lenders"). By using the Site, you agree to the terms of this Privacy Policy.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ marginTop: 4 }} color="primary">
          1. Information We Collect
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              primary="• Information You Provide Directly"
              secondary={
    <>
      {"o When you complete a loan inquiry form, we collect information such as your business name, contact information (name, email address, phone number), business address, business financial information (revenue, years in business), loan amount requested, and other relevant details."}
      <br />
      <br />
      {"o If you contact us directly (e.g., via email or phone), we may collect the information you provide during the communication."}
    </>
  }           
            />
            
          </ListItem>
          <ListItem>
            <ListItemText
              primary="• Information Collected Automatically"
              secondary={
    <>
      {"o We may automatically collect certain information about your use of the Site, including your IP address, browser type, operating system, referring URLs, pages visited, and the dates and times of your visits."}
      <br />
      <br />
      {"o We may use cookies, web beacons, and similar technologies to collect this information. You can control cookies through your browser settings, but disabling cookies may affect your ability to use certain features of the Site.   "}
    </>
  }   
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="• Information from Third Parties"
              secondary="o	We may receive information about you from Lenders or other third-party service providers, such as credit bureaus or data aggregators, to verify your information or improve our services."
            />
          </ListItem>
        </List>

        <Divider sx={{ marginY: 4 }} />

        <Typography variant="h6" fontWeight="bold" color="primary">
          2. How We Use Your Information
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Connecting you with Lenders who may provide business loan options." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Verifying your information and assessing your eligibility for loans." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Improving the Site and our services." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Responding to your inquiries and providing customer support." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Sending marketing and promotional materials (opt-out anytime)." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Preventing fraud and ensuring site security." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Complying with legal obligations." />
          </ListItem>
        </List>

        <Divider sx={{ marginY: 4 }} />

        <Typography variant="h6" fontWeight="bold" color="primary">
          3. Sharing Your Information
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Lenders: We share loan inquiry details with lenders to provide loan options." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Third-Party Service Providers: We may share data with hosting, analytics, and marketing service providers." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Credit Bureaus: Your data may be shared for verification and creditworthiness assessment." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Legal Authorities: We may disclose data when required by law." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Business Transfers: In case of merger/acquisition, your data may be transferred." />
          </ListItem>
        </List>

        <Divider sx={{ marginY: 4 }} />

        <Typography variant="h6" fontWeight="bold" color="primary">
          4. Data Security
        </Typography>
        <Typography variant="body1" paragraph>
        We take reasonable measures to protect your information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure, so we cannot guarantee absolute security.   
        </Typography>
        <Divider sx={{ marginY: 4 }} />
        <Typography variant="h6" fontWeight="bold" color="primary">
          5. Data Retention
        </Typography>
        <Typography variant="body1" paragraph>
        We retain your information for as long as necessary to fulfill the purposes described in this Privacy Policy, unless a longer retention period is required or permitted by law.   
        </Typography>

        <Divider sx={{ marginY: 4 }} />

        <Typography variant="h6" fontWeight="bold" color="primary">
          6. Your Rights
        </Typography>
        <Typography variant="body1" paragraph>
          Depending on your location, you may have rights to access, modify, delete, or restrict your data. You may also opt out of marketing communications.
        </Typography>
        <Divider sx={{ marginY: 4 }} />
        <Typography variant="h6" fontWeight="bold" color="primary">
          7. Children's Privacy
        </Typography>
        <Typography variant="body1" paragraph>
        Our Site is not intended for children under the age of 18. We do not knowingly collect personal information from children under 18. If we become aware that we have collected personal information from a child under 18, we will take steps to delete it.   
        </Typography>
        <Divider sx={{ marginY: 4 }} />
        <Typography variant="h6" fontWeight="bold" color="primary">
          8. Changes to this Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
        We may update this Privacy Policy from time to time. We will post any changes on this page and update the "Last Updated" date. We encourage you to review this Privacy Policy periodically.   
        </Typography>
        <Divider sx={{ marginY: 4 }} />
        <Typography variant="h6" fontWeight="bold" color="primary">
          9. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions, reach out to us at:
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Smyan Tech Solutions Pvt Ltd</strong><br />
          Bldg no. 145, Sector 44, Gurgaon, Haryana – 122003
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Email: contact@dequitec.com</strong>
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
